// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationParameterDerivedArchiveId = (z.number());
export const fermentationParameterDerivedArchive = z.object({
    id: fermentationParameterDerivedArchiveId,
    fermentation_id: z.number().nullable(),
    parameter_type_id: z.number().nullable(),
    line_type_id: z.number().nullable(),
    effective_at: z.date().nullable(),
    number_value: z.string().nullable(),
    formula: z.string().nullable(),
    ramp_from: z.string().nullable(),
    ramp_duration_h: z.string().nullable(),
    source_type: z.string().nullable(),
    source_protocol_id: z.number().nullable(),
    protocol_application_id: z.number().nullable(),
    operator_id: z.number().nullable(),
    reason: z.string().nullable(),
    created_at: z.date().nullable(),
    created_by: z.number().nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: z.number().nullable(),
});
export const fermentationParameterDerivedArchiveInitializer = z.object({
    id: fermentationParameterDerivedArchiveId,
    fermentation_id: z.number().optional().nullable(),
    parameter_type_id: z.number().optional().nullable(),
    line_type_id: z.number().optional().nullable(),
    effective_at: z.date().optional().nullable(),
    number_value: z.string().optional().nullable(),
    formula: z.string().optional().nullable(),
    ramp_from: z.string().optional().nullable(),
    ramp_duration_h: z.string().optional().nullable(),
    source_type: z.string().optional().nullable(),
    source_protocol_id: z.number().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    operator_id: z.number().optional().nullable(),
    reason: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    created_by: z.number().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: z.number().optional().nullable(),
});
export const fermentationParameterDerivedArchiveMutator = z.object({
    id: fermentationParameterDerivedArchiveId.optional(),
    fermentation_id: z.number().optional().nullable(),
    parameter_type_id: z.number().optional().nullable(),
    line_type_id: z.number().optional().nullable(),
    effective_at: z.date().optional().nullable(),
    number_value: z.string().optional().nullable(),
    formula: z.string().optional().nullable(),
    ramp_from: z.string().optional().nullable(),
    ramp_duration_h: z.string().optional().nullable(),
    source_type: z.string().optional().nullable(),
    source_protocol_id: z.number().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    operator_id: z.number().optional().nullable(),
    reason: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    created_by: z.number().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: z.number().optional().nullable(),
});
//# sourceMappingURL=FermentationParameterDerivedArchive.js.map